import { Stack, Text, SegmentedControl, Group } from '@mantine/core';

const CATEGORIES = [
  { value: 'affected', label: 'Affected', color: '#16a34a', icon: 'fa-house', description: 'Damage does not render home uninhabitable' },
  { value: 'minor', label: 'Minor', color: '#d97706', icon: 'fa-house-crack', description: 'Home damaged but habitable with repairs' },
  { value: 'major', label: 'Major', color: '#ea580c', icon: 'fa-house-chimney-crack', description: 'Home is not safe to occupy without significant repairs' },
  { value: 'destroyed', label: 'Destroyed', color: '#dc2626', icon: 'fa-house-fire', description: 'Structure is a total loss or not economically repairable' },
  { value: 'inaccessible', label: 'Inaccessible', color: '#7c3aed', icon: 'fa-road-barrier', description: 'Area cannot be accessed for assessment' },
];

interface Props {
  value: string;
  onChange: (val: string) => void;
}

export default function DamageCategorySelector({ value, onChange }: Props) {
  const selected = CATEGORIES.find(c => c.value === value);

  return (
    <Stack gap="xs">
      <Text fw={500} size="sm">FEMA Damage Category</Text>
      <SegmentedControl
        value={value || ''}
        onChange={onChange}
        data={CATEGORIES.map(c => ({
          value: c.value,
          label: (
            <Group gap={6} wrap="nowrap" justify="center">
              <div style={{ width: 10, height: 10, borderRadius: '50%', background: c.color, flexShrink: 0 }} />
              <Text size="xs" fw={600} ta="center">{c.label}</Text>
            </Group>
          ),
        }))}
        fullWidth
        size="md"
        styles={{ root: { flexWrap: 'wrap' } }}
      />
      {selected && (
        <Text size="xs" c="dimmed" fs="italic">{selected.description}</Text>
      )}
    </Stack>
  );
}
